import { useMemo } from 'react'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import { useIntl } from 'react-intl'

const MEMBER_PRICES_VALUE = 'Member prices'

interface Props {
  luxPlusPriceFacet?: App.CruiseSearchFacet
  hasLuxPlusPrice?: Set<string>
  onChange: (nextFilters: Record<string, any>) => void
}

function CruiseLuxPlusPriceFilter({ luxPlusPriceFacet, hasLuxPlusPrice, onChange }: Props) {
  const intl = useIntl()

  const items = useMemo(() => [{
    value: MEMBER_PRICES_VALUE,
    label: intl.formatMessage({
      id: 'ZAsXpI0jQkx2g5IhkB1A',
      defaultMessage: 'Member prices',
      description: 'Label for the LuxPlus+ member prices filter checkbox in cruise search',
    }),
    count: luxPlusPriceFacet?.count || 0,
  }], [intl, luxPlusPriceFacet])

  return <FilterPanelCheckboxGroup
    name="hasLuxPlusPrice"
    items={items}
    onChange={onChange}
    defaultSelected={hasLuxPlusPrice}
  />
}

export default CruiseLuxPlusPriceFilter
